import styled from 'styled-components';

import { Flex } from '@/components/base';
import ToggleRadio from '@/components/Common/ToggleRadio';
import Typo from '@/components/Typography/Typo';

import type { FrontInboxInfoT } from '../types/types';

type FrontWorkspaceInboxItemProps = {
  info: FrontInboxInfoT;
  isActive: boolean;
  onChangeActive: (info: FrontInboxInfoT) => void;
};

const FrontWorkspaceInboxItem = (props: FrontWorkspaceInboxItemProps) => {
  return (
    <ItemStyle d="column" style={{ width: '45%' }} g="8px">
      <Flex j="space-between">
        <Flex g="4px" a="center">
          <Typo type="label2">{props.info.name}</Typo>
        </Flex>
        <ToggleRadio
          status={props.isActive}
          onChange={() => props.onChangeActive(props.info)}
        />
      </Flex>
    </ItemStyle>
  );
};

export default FrontWorkspaceInboxItem;

const ItemStyle = styled(Flex)`
  padding: 16px 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray300};
`;
